export default __webpack_public_path__ + "static/media/prismaIsoDark.124cf3d4.png";